import React from 'react';
import {bool, string, element, func} from 'prop-types';
import {CSSTransition} from 'react-transition-group';
import styles from './mobileNavAnimations.scss';
import ScrollLock from '../ScrollLock';

export default class MobileNavAnimationSlide extends React.Component {
    constructor() {
        super();

        this.state = {
            isScrollLocked: false
        };

        this.lockScroll = this.toggleScroll.bind(this, true);
        this.unlockScroll = this.toggleScroll.bind(this, false);
    }

    toggleScroll(isScrollLocked) {
        if (this.props.scrollLock) {
            this.setState({
                isScrollLocked
            });
        }
    }

    render() {
        const {appear, leave, children, onAnimationEnd} = this.props;
        const classNames = {
            enter: styles[`${appear}Enter`],
            enterActive: styles[`${appear}ActiveEnter`],
            exit: styles.exit,
            exitActive: styles[`${leave}ActiveExit`]
        };

        return (
            <ScrollLock isLocked={this.state.isScrollLocked}>
                <CSSTransition
                    classNames={classNames}
                    timeout={20000} // addEndListener does the magic, the lib just requires this to be set
                    in={this.props.in}
                    mountOnEnter
                    unmountOnExit
                    onExit={this.unlockScroll}
                    onEntered={this.lockScroll}
                    onExited={onAnimationEnd}
                    addEndListener={(node, done) => {
                        // use the css transitionend event to mark the finish of a transition
                        node.addEventListener('transitionend', done, false);
                    }}
                >
                    {children}
                </CSSTransition>
            </ScrollLock>
        );
    }
}

MobileNavAnimationSlide.defaultProps = {
    appear: 'left',
    leave: 'left',
    onAnimationEnd: () => {}
};

MobileNavAnimationSlide.propTypes = {
    scrollLock: bool,
    in: bool,
    appear: string,
    leave: string,
    children: element,
    onAnimationEnd: func
};



// WEBPACK FOOTER //
// ./src/components/MobileNav/MobileNavAnimations/MobileNavAnimationSlide.jsx